import React, { useEffect } from 'react';
import { Segment } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';

import { Menu } from 'src/components/custom';
import { useAppSelector } from 'src/store';
import { actions, siderMenuSelector } from 'src/store/ui/menu';
import { isAdminSelector } from 'src/utils/helper';
import { useDispatch } from 'react-redux';

export const ALL = {
  all_members: 'All members',
  all_questions: 'All questions',
};

const Sider: React.FC = () => {
  const { pathname } = useLocation();

  const subPathname = pathname.split('/')[2];

  const menu = useAppSelector((state) => siderMenuSelector(state, pathname));

  const hasAll = !!ALL[subPathname];

  const dispatch = useDispatch();

  const isAdmin = useAppSelector(isAdminSelector);

  useEffect(() => {
    dispatch(actions.setAdminState(isAdmin as boolean));
  }, [isAdmin, dispatch]);

  return (
    <Segment className="p-12">
      <Menu
        menu={menu}
        activeKeys={
          hasAll ? [String(subPathname), 'undefined'] : [String(subPathname)]
        }
      />
    </Segment>
  );
};

export default Sider;
